.avatar {
  vertical-align: middle;
}
